export default __webpack_public_path__ + "static/media/video-bg.40bea1fd.webp";